import lotSizeCalculatorFilter from './lotSizeCalculatorFilter'
import tradeSimulatorFilter from './tradeSimulatorFilter'
import backtesterFilter from './backtesterFilter'

const filters = {
  lotSizeCalculator: lotSizeCalculatorFilter,
  patternAlerts: undefined,
  navigationBar: undefined,
  tradingSimulator: tradeSimulatorFilter,
  backtester: backtesterFilter,
  symbolSelect: undefined,
}

export default filters
